import { css } from '@emotion/react';
import { Question } from '@phosphor-icons/react';
import { Empty } from 'client/components/Empty';
import { Dashboard } from 'client/components/Layout/Dashboard';

const dashboardStyle = css`
  align-items: center;
  justify-content: center;
`;

export const DeploymentNotFound = () => (
  <Dashboard css={dashboardStyle}>
    <Empty
      icon={<Question />}
      title="Deployment not found"
      subtitle="This deployment might have been deleted, or it may have never existed at all…"
    ></Empty>
  </Dashboard>
);
